"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelPrintStatus = void 0;
var LabelPrintStatus;
(function (LabelPrintStatus) {
    LabelPrintStatus[LabelPrintStatus["Cleared"] = 0] = "Cleared";
    LabelPrintStatus[LabelPrintStatus["Saved"] = 1] = "Saved";
    LabelPrintStatus[LabelPrintStatus["Printed"] = 2] = "Printed";
})(LabelPrintStatus = exports.LabelPrintStatus || (exports.LabelPrintStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/print-labels.ts
// module id = 3704
// module chunks = 0